var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllbridge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: "100%",
    preserveAspectRatio: "none",
    viewBox: "0 0 180 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6071 48.4118V46H45.718L53.829 54.2286V68.274H51.4517V55.3636L44.5994 48.4118H37.6071Z",
    fill: "#AAAAB6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9554 56.6404L43.3404 51.9586H36.3481L34.1108 54.2286V46.1418H31.7331V63.5922L36.3481 68.274H43.3404L45.5781 66.004V74.0908H48.0954V60.6129L47.9554 56.6404ZM42.2216 65.8621H37.607L34.2504 62.4572V57.7754L37.607 54.3705H42.2216L45.5781 57.7754V62.4572L42.2216 65.8621Z",
    fill: "#AAAAB6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.914 54.2283C124.173 54.2283 125.431 54.7957 126.41 55.5052V49.4046H128.648V60.0451C128.648 63.1663 125.991 65.8618 122.914 65.8618C119.838 65.8618 117.18 63.3081 117.18 60.0451C117.18 56.9238 119.698 54.2283 122.914 54.2283ZM119.278 60.1869C119.278 62.1732 120.816 63.7337 122.774 63.7337C124.732 63.7337 126.27 62.1732 126.27 60.1869C126.27 58.2007 124.732 56.6401 122.774 56.6401C120.816 56.6401 119.278 58.2007 119.278 60.1869Z",
    fill: "#AAAAB6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.666 49.547H76.9033V63.7342H80.3995V66.0042H74.666V49.547Z",
    fill: "#AAAAB6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7776 49.547H85.0152V63.7342H88.5112V66.0042H82.7776V49.547Z",
    fill: "#AAAAB6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.572 66.004V56.6404H110.187V54.2286H103.195V66.004H105.572Z",
    fill: "#AAAAB6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.705 54.2286H114.942V66.004H112.705V54.2286Z",
    fill: "#AAAAB6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.7835 54.2288C94.3853 54.2288 93.2663 54.6544 92.2875 55.5057V49.547H90.0501V60.1875C90.0501 63.4505 92.7068 66.0042 95.7835 66.0042C98.8602 66.0042 101.518 63.3086 101.518 60.1875C101.657 56.9244 98.9998 54.2288 95.7835 54.2288ZM95.7835 63.7342C93.8258 63.7342 92.2875 62.1737 92.2875 60.1875C92.2875 58.2012 93.8258 56.6406 95.7835 56.6406C97.7412 56.6406 99.2795 58.2012 99.2795 60.1875C99.2795 62.1737 97.7412 63.7342 95.7835 63.7342Z",
    fill: "#AAAAB6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.92 54.2286C132.703 54.2286 130.186 56.9241 130.186 60.0454C130.186 63.3084 132.843 65.8621 135.92 65.8621C137.178 65.8621 138.437 65.4365 139.416 64.7272V67.5646C139.276 69.409 137.738 70.8277 135.92 70.8277C133.962 70.8277 132.424 69.2671 132.424 67.2809H130.186C130.186 70.5439 132.843 73.0977 135.92 73.0977C138.996 73.0977 141.513 70.6858 141.654 67.5646V60.0454C141.793 56.9241 139.136 54.2286 135.92 54.2286ZM135.92 63.734C133.962 63.734 132.424 62.1734 132.424 60.1873C132.424 58.201 133.962 56.6404 135.92 56.6404C137.877 56.6404 139.416 58.201 139.416 60.1873V60.6129C139.276 62.3153 137.738 63.734 135.92 63.734Z",
    fill: "#AAAAB6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.128 62.3153C146.828 63.1666 147.806 63.734 148.925 63.734C150.044 63.734 151.023 63.1666 151.722 62.1735L153.96 62.8828C152.981 64.7272 151.023 65.8621 148.925 65.8621C145.849 65.8621 143.192 63.3084 143.192 60.0454C143.192 56.9241 145.709 54.2286 148.925 54.2286C151.862 54.2286 154.239 56.4985 154.659 59.336L146.128 62.3153ZM151.722 58.0592C151.023 57.2079 150.044 56.6404 148.925 56.6404C146.967 56.6404 145.429 58.201 145.429 60.1873L151.722 58.0592Z",
    fill: "#AAAAB6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.6825 57.7754L64.1786 54.2286H68.9332L72.4294 57.7754V66.1459H70.052V65.0109L68.9332 66.1459H64.1786L60.6825 62.5991V57.7754ZM65.1574 63.734H67.9544L70.052 61.7478V58.7685L67.9544 56.6404H65.1574L63.0598 58.7685V61.6059L65.1574 63.734Z",
    fill: "#AAAAB6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3773 64.869V51.9586H26V66.004L34.1112 74.2326H42.222V71.8208H35.2296L28.3773 64.869Z",
    fill: "#AAAAB6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllbridge);
export default __webpack_public_path__ + "static/media/allbridge.e151530fca958f33af175c74375db4d2.svg";
export { ForwardRef as ReactComponent };